/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { ActiveReminderResponse } from '../models/activeReminderResponse';

import type { CreateEntityReminderRequest } from '../models/createEntityReminderRequest';

import type { DismissReminderApiV1RemindersReminderIdDismissPost200 } from '../models/dismissReminderApiV1RemindersReminderIdDismissPost200';

import type { EntityReminder } from '../models/entityReminder';

import type { EntityReminderList } from '../models/entityReminderList';

import type { GetActiveRemindersApiV1RemindersActiveGetParams } from '../models/getActiveRemindersApiV1RemindersActiveGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams } from '../models/listUpcomingRemindersApiV1RemindersEntityUpcomingGetParams';

import type { ReminderRuleResponse } from '../models/reminderRuleResponse';

import type { SnoozeReminderApiV1RemindersReminderIdSnoozePost200 } from '../models/snoozeReminderApiV1RemindersReminderIdSnoozePost200';

import type { SnoozeRequest } from '../models/snoozeRequest';

import type { TenantReminderSettingsResponse } from '../models/tenantReminderSettingsResponse';

import type { UpdateEntityReminderRequest } from '../models/updateEntityReminderRequest';

import type { UpdateTenantReminderSettingsRequest } from '../models/updateTenantReminderSettingsRequest';

import type { UpdateUserReminderSettingsRequest } from '../models/updateUserReminderSettingsRequest';

import type { UserReminderSettingsResponse } from '../models/userReminderSettingsResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List all registered reminder rules with their defaults.
 * @summary List Reminder Rules
 */
export const listReminderRulesApiV1RemindersRulesGet = (
  signal?: AbortSignal
) => {
  return customInstance<ReminderRuleResponse[]>({
    url: `/api/v1/reminders/rules`,
    method: 'GET',
    signal
  });
};

export const getListReminderRulesApiV1RemindersRulesGetQueryKey = () => {
  return [`/api/v1/reminders/rules`] as const;
};

export const getListReminderRulesApiV1RemindersRulesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListReminderRulesApiV1RemindersRulesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>
  > = ({ signal }) => listReminderRulesApiV1RemindersRulesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListReminderRulesApiV1RemindersRulesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>
>;
export type ListReminderRulesApiV1RemindersRulesGetQueryError = unknown;

export function useListReminderRulesApiV1RemindersRulesGet<
  TData = Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
          TError,
          Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReminderRulesApiV1RemindersRulesGet<
  TData = Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
          TError,
          Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReminderRulesApiV1RemindersRulesGet<
  TData = Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Reminder Rules
 */

export function useListReminderRulesApiV1RemindersRulesGet<
  TData = Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReminderRulesApiV1RemindersRulesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReminderRulesApiV1RemindersRulesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get current user's reminder settings (overrides) for all rules.
 * @summary Get User Reminder Settings
 */
export const getUserReminderSettingsApiV1RemindersSettingsGet = (
  signal?: AbortSignal
) => {
  return customInstance<UserReminderSettingsResponse[]>({
    url: `/api/v1/reminders/settings`,
    method: 'GET',
    signal
  });
};

export const getGetUserReminderSettingsApiV1RemindersSettingsGetQueryKey =
  () => {
    return [`/api/v1/reminders/settings`] as const;
  };

export const getGetUserReminderSettingsApiV1RemindersSettingsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserReminderSettingsApiV1RemindersSettingsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>>
  > = ({ signal }) => getUserReminderSettingsApiV1RemindersSettingsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserReminderSettingsApiV1RemindersSettingsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>>
  >;
export type GetUserReminderSettingsApiV1RemindersSettingsGetQueryError =
  unknown;

export function useGetUserReminderSettingsApiV1RemindersSettingsGet<
  TData = Awaited<
    ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserReminderSettingsApiV1RemindersSettingsGet<
  TData = Awaited<
    ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserReminderSettingsApiV1RemindersSettingsGet<
  TData = Awaited<
    ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Reminder Settings
 */

export function useGetUserReminderSettingsApiV1RemindersSettingsGet<
  TData = Awaited<
    ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserReminderSettingsApiV1RemindersSettingsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserReminderSettingsApiV1RemindersSettingsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current user's settings for a specific reminder rule.
 * @summary Update User Reminder Settings
 */
export const updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut = (
  ruleId: string,
  updateUserReminderSettingsRequest: UpdateUserReminderSettingsRequest
) => {
  return customInstance<UserReminderSettingsResponse>({
    url: `/api/v1/reminders/settings/${ruleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUserReminderSettingsRequest
  });
};

export const getUpdateUserReminderSettingsApiV1RemindersSettingsRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut
        >
      >,
      TError,
      { ruleId: string; data: UpdateUserReminderSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: UpdateUserReminderSettingsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut
        >
      >,
      { ruleId: string; data: UpdateUserReminderSettingsRequest }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut(
        ruleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateUserReminderSettingsApiV1RemindersSettingsRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut
      >
    >
  >;
export type UpdateUserReminderSettingsApiV1RemindersSettingsRuleIdPutMutationBody =
  UpdateUserReminderSettingsRequest;
export type UpdateUserReminderSettingsApiV1RemindersSettingsRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Reminder Settings
 */
export const useUpdateUserReminderSettingsApiV1RemindersSettingsRuleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut
        >
      >,
      TError,
      { ruleId: string; data: UpdateUserReminderSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateUserReminderSettingsApiV1RemindersSettingsRuleIdPut>
  >,
  TError,
  { ruleId: string; data: UpdateUserReminderSettingsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateUserReminderSettingsApiV1RemindersSettingsRuleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get the tenant's cadence/threshold overrides for all rules (admin only).

These set the tenant-wide defaults every target resolves against (external
participant nags have no per-user row, so this is their only override layer);
per-user settings still layer on top for internal recipients.
 * @summary Get Tenant Reminder Settings
 */
export const getTenantReminderSettingsApiV1RemindersTenantSettingsGet = (
  signal?: AbortSignal
) => {
  return customInstance<TenantReminderSettingsResponse[]>({
    url: `/api/v1/reminders/tenant-settings`,
    method: 'GET',
    signal
  });
};

export const getGetTenantReminderSettingsApiV1RemindersTenantSettingsGetQueryKey =
  () => {
    return [`/api/v1/reminders/tenant-settings`] as const;
  };

export const getGetTenantReminderSettingsApiV1RemindersTenantSettingsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantReminderSettingsApiV1RemindersTenantSettingsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
        >
      >
    > = ({ signal }) =>
      getTenantReminderSettingsApiV1RemindersTenantSettingsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantReminderSettingsApiV1RemindersTenantSettingsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
      >
    >
  >;
export type GetTenantReminderSettingsApiV1RemindersTenantSettingsGetQueryError =
  unknown;

export function useGetTenantReminderSettingsApiV1RemindersTenantSettingsGet<
  TData = Awaited<
    ReturnType<typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantReminderSettingsApiV1RemindersTenantSettingsGet<
  TData = Awaited<
    ReturnType<typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantReminderSettingsApiV1RemindersTenantSettingsGet<
  TData = Awaited<
    ReturnType<typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Reminder Settings
 */

export function useGetTenantReminderSettingsApiV1RemindersTenantSettingsGet<
  TData = Awaited<
    ReturnType<typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantReminderSettingsApiV1RemindersTenantSettingsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantReminderSettingsApiV1RemindersTenantSettingsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the tenant's cadence/thresholds for a specific rule (admin only).
 * @summary Update Tenant Reminder Settings
 */
export const updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut =
  (
    ruleId: string,
    updateTenantReminderSettingsRequest: UpdateTenantReminderSettingsRequest
  ) => {
    return customInstance<TenantReminderSettingsResponse>({
      url: `/api/v1/reminders/tenant-settings/${ruleId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTenantReminderSettingsRequest
    });
  };

export const getUpdateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut
        >
      >,
      TError,
      { ruleId: string; data: UpdateTenantReminderSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: UpdateTenantReminderSettingsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut
        >
      >,
      { ruleId: string; data: UpdateTenantReminderSettingsRequest }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut(
        ruleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut
      >
    >
  >;
export type UpdateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPutMutationBody =
  UpdateTenantReminderSettingsRequest;
export type UpdateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Reminder Settings
 */
export const useUpdateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut
          >
        >,
        TError,
        { ruleId: string; data: UpdateTenantReminderSettingsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPut
      >
    >,
    TError,
    { ruleId: string; data: UpdateTenantReminderSettingsRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateTenantReminderSettingsApiV1RemindersTenantSettingsRuleIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get current user's active/pending reminders.

Shape B (``docs/design-system/ui-list-pages.md`` § 11): the reminders panel
renders the whole open queue, so an omitted ``limit`` resolves to
``MAX_LIST_LIMIT`` rather than to a page size — a hidden cap would drop a nag
off the panel with nothing to say so. Unlike its two settings siblings above,
this one is NOT bounded by the rule registry: a user accumulates a row per
(rule, entity) pair, so the backstop is the only thing bounding it.
 * @summary Get Active Reminders
 */
export const getActiveRemindersApiV1RemindersActiveGet = (
  params?: GetActiveRemindersApiV1RemindersActiveGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ActiveReminderResponse[]>({
    url: `/api/v1/reminders/active`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetActiveRemindersApiV1RemindersActiveGetQueryKey = (
  params?: GetActiveRemindersApiV1RemindersActiveGetParams
) => {
  return [`/api/v1/reminders/active`, ...(params ? [params] : [])] as const;
};

export const getGetActiveRemindersApiV1RemindersActiveGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
  TError = HTTPValidationError
>(
  params?: GetActiveRemindersApiV1RemindersActiveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetActiveRemindersApiV1RemindersActiveGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>
  > = ({ signal }) => getActiveRemindersApiV1RemindersActiveGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetActiveRemindersApiV1RemindersActiveGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>
>;
export type GetActiveRemindersApiV1RemindersActiveGetQueryError =
  HTTPValidationError;

export function useGetActiveRemindersApiV1RemindersActiveGet<
  TData = Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetActiveRemindersApiV1RemindersActiveGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
          TError,
          Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetActiveRemindersApiV1RemindersActiveGet<
  TData = Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
  TError = HTTPValidationError
>(
  params?: GetActiveRemindersApiV1RemindersActiveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
          TError,
          Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveRemindersApiV1RemindersActiveGet<
  TData = Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
  TError = HTTPValidationError
>(
  params?: GetActiveRemindersApiV1RemindersActiveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Active Reminders
 */

export function useGetActiveRemindersApiV1RemindersActiveGet<
  TData = Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
  TError = HTTPValidationError
>(
  params?: GetActiveRemindersApiV1RemindersActiveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveRemindersApiV1RemindersActiveGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetActiveRemindersApiV1RemindersActiveGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Dismiss a specific reminder.
 * @summary Dismiss Reminder
 */
export const dismissReminderApiV1RemindersReminderIdDismissPost = (
  reminderId: string,
  signal?: AbortSignal
) => {
  return customInstance<DismissReminderApiV1RemindersReminderIdDismissPost200>({
    url: `/api/v1/reminders/${reminderId}/dismiss`,
    method: 'POST',
    signal
  });
};

export const getDismissReminderApiV1RemindersReminderIdDismissPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof dismissReminderApiV1RemindersReminderIdDismissPost>
      >,
      TError,
      { reminderId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof dismissReminderApiV1RemindersReminderIdDismissPost>
    >,
    TError,
    { reminderId: string },
    TContext
  > => {
    const mutationKey = ['dismissReminderApiV1RemindersReminderIdDismissPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof dismissReminderApiV1RemindersReminderIdDismissPost>
      >,
      { reminderId: string }
    > = (props) => {
      const { reminderId } = props ?? {};

      return dismissReminderApiV1RemindersReminderIdDismissPost(reminderId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DismissReminderApiV1RemindersReminderIdDismissPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof dismissReminderApiV1RemindersReminderIdDismissPost>
    >
  >;

export type DismissReminderApiV1RemindersReminderIdDismissPostMutationError =
  HTTPValidationError;

/**
 * @summary Dismiss Reminder
 */
export const useDismissReminderApiV1RemindersReminderIdDismissPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof dismissReminderApiV1RemindersReminderIdDismissPost>
      >,
      TError,
      { reminderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof dismissReminderApiV1RemindersReminderIdDismissPost>
  >,
  TError,
  { reminderId: string },
  TContext
> => {
  const mutationOptions =
    getDismissReminderApiV1RemindersReminderIdDismissPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Snooze a specific reminder, by duration or to a chosen instant.
 * @summary Snooze Reminder
 */
export const snoozeReminderApiV1RemindersReminderIdSnoozePost = (
  reminderId: string,
  snoozeRequest: SnoozeRequest,
  signal?: AbortSignal
) => {
  return customInstance<SnoozeReminderApiV1RemindersReminderIdSnoozePost200>({
    url: `/api/v1/reminders/${reminderId}/snooze`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: snoozeRequest,
    signal
  });
};

export const getSnoozeReminderApiV1RemindersReminderIdSnoozePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof snoozeReminderApiV1RemindersReminderIdSnoozePost>
      >,
      TError,
      { reminderId: string; data: SnoozeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof snoozeReminderApiV1RemindersReminderIdSnoozePost>
    >,
    TError,
    { reminderId: string; data: SnoozeRequest },
    TContext
  > => {
    const mutationKey = ['snoozeReminderApiV1RemindersReminderIdSnoozePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof snoozeReminderApiV1RemindersReminderIdSnoozePost>
      >,
      { reminderId: string; data: SnoozeRequest }
    > = (props) => {
      const { reminderId, data } = props ?? {};

      return snoozeReminderApiV1RemindersReminderIdSnoozePost(reminderId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type SnoozeReminderApiV1RemindersReminderIdSnoozePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof snoozeReminderApiV1RemindersReminderIdSnoozePost>>
  >;
export type SnoozeReminderApiV1RemindersReminderIdSnoozePostMutationBody =
  SnoozeRequest;
export type SnoozeReminderApiV1RemindersReminderIdSnoozePostMutationError =
  HTTPValidationError;

/**
 * @summary Snooze Reminder
 */
export const useSnoozeReminderApiV1RemindersReminderIdSnoozePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof snoozeReminderApiV1RemindersReminderIdSnoozePost>
      >,
      TError,
      { reminderId: string; data: SnoozeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof snoozeReminderApiV1RemindersReminderIdSnoozePost>>,
  TError,
  { reminderId: string; data: SnoozeRequest },
  TContext
> => {
  const mutationOptions =
    getSnoozeReminderApiV1RemindersReminderIdSnoozePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Schedule a reminder on an entity the caller can see.
 * @summary Create Entity Reminder
 */
export const createEntityReminderApiV1RemindersEntityPost = (
  createEntityReminderRequest: CreateEntityReminderRequest,
  signal?: AbortSignal
) => {
  return customInstance<EntityReminder>({
    url: `/api/v1/reminders/entity`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEntityReminderRequest,
    signal
  });
};

export const getCreateEntityReminderApiV1RemindersEntityPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntityReminderApiV1RemindersEntityPost>>,
    TError,
    { data: CreateEntityReminderRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntityReminderApiV1RemindersEntityPost>>,
  TError,
  { data: CreateEntityReminderRequest },
  TContext
> => {
  const mutationKey = ['createEntityReminderApiV1RemindersEntityPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntityReminderApiV1RemindersEntityPost>>,
    { data: CreateEntityReminderRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createEntityReminderApiV1RemindersEntityPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityReminderApiV1RemindersEntityPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createEntityReminderApiV1RemindersEntityPost>>
  >;
export type CreateEntityReminderApiV1RemindersEntityPostMutationBody =
  CreateEntityReminderRequest;
export type CreateEntityReminderApiV1RemindersEntityPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Entity Reminder
 */
export const useCreateEntityReminderApiV1RemindersEntityPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEntityReminderApiV1RemindersEntityPost>>,
      TError,
      { data: CreateEntityReminderRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createEntityReminderApiV1RemindersEntityPost>>,
  TError,
  { data: CreateEntityReminderRequest },
  TContext
> => {
  const mutationOptions =
    getCreateEntityReminderApiV1RemindersEntityPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The caller's pending reminders as a recipient — the bell's section.
 * @summary List Upcoming Reminders
 */
export const listUpcomingRemindersApiV1RemindersEntityUpcomingGet = (
  params?: ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<EntityReminderList>({
    url: `/api/v1/reminders/entity/upcoming`,
    method: 'GET',
    params,
    signal
  });
};

export const getListUpcomingRemindersApiV1RemindersEntityUpcomingGetQueryKey = (
  params?: ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams
) => {
  return [
    `/api/v1/reminders/entity/upcoming`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListUpcomingRemindersApiV1RemindersEntityUpcomingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUpcomingRemindersApiV1RemindersEntityUpcomingGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
      >
    > = ({ signal }) =>
      listUpcomingRemindersApiV1RemindersEntityUpcomingGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUpcomingRemindersApiV1RemindersEntityUpcomingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
    >
  >;
export type ListUpcomingRemindersApiV1RemindersEntityUpcomingGetQueryError =
  HTTPValidationError;

export function useListUpcomingRemindersApiV1RemindersEntityUpcomingGet<
  TData = Awaited<
    ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUpcomingRemindersApiV1RemindersEntityUpcomingGet<
  TData = Awaited<
    ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUpcomingRemindersApiV1RemindersEntityUpcomingGet<
  TData = Awaited<
    ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Upcoming Reminders
 */

export function useListUpcomingRemindersApiV1RemindersEntityUpcomingGet<
  TData = Awaited<
    ReturnType<typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUpcomingRemindersApiV1RemindersEntityUpcomingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingRemindersApiV1RemindersEntityUpcomingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUpcomingRemindersApiV1RemindersEntityUpcomingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The caller's own pending reminders on one entity — the popover list.
 * @summary List Entity Reminders
 */
export const listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet = (
  entityType: string,
  entityId: string,
  signal?: AbortSignal
) => {
  return customInstance<EntityReminderList>({
    url: `/api/v1/reminders/entity/${entityType}/${entityId}`,
    method: 'GET',
    signal
  });
};

export const getListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGetQueryKey =
  (entityType?: string, entityId?: string) => {
    return [`/api/v1/reminders/entity/${entityType}/${entityId}`] as const;
  };

export const getListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    entityType: string,
    entityId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGetQueryKey(
        entityType,
        entityId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
        >
      >
    > = ({ signal }) =>
      listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet(
        entityType,
        entityId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(entityType && entityId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
      >
    >
  >;
export type ListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGetQueryError =
  HTTPValidationError;

export function useListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet<
  TData = Awaited<
    ReturnType<
      typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
    >
  >,
  TError = HTTPValidationError
>(
  entityType: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet<
  TData = Awaited<
    ReturnType<
      typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
    >
  >,
  TError = HTTPValidationError
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet<
  TData = Awaited<
    ReturnType<
      typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
    >
  >,
  TError = HTTPValidationError
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Entity Reminders
 */

export function useListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet<
  TData = Awaited<
    ReturnType<
      typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
    >
  >,
  TError = HTTPValidationError
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEntityRemindersApiV1RemindersEntityEntityTypeEntityIdGetQueryOptions(
      entityType,
      entityId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit a pending reminder. Creator only.
 * @summary Update Entity Reminder
 */
export const updateEntityReminderApiV1RemindersEntityReminderIdPatch = (
  reminderId: string,
  updateEntityReminderRequest: UpdateEntityReminderRequest
) => {
  return customInstance<EntityReminder>({
    url: `/api/v1/reminders/entity/${reminderId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateEntityReminderRequest
  });
};

export const getUpdateEntityReminderApiV1RemindersEntityReminderIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateEntityReminderApiV1RemindersEntityReminderIdPatch
        >
      >,
      TError,
      { reminderId: string; data: UpdateEntityReminderRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateEntityReminderApiV1RemindersEntityReminderIdPatch>
    >,
    TError,
    { reminderId: string; data: UpdateEntityReminderRequest },
    TContext
  > => {
    const mutationKey = [
      'updateEntityReminderApiV1RemindersEntityReminderIdPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateEntityReminderApiV1RemindersEntityReminderIdPatch
        >
      >,
      { reminderId: string; data: UpdateEntityReminderRequest }
    > = (props) => {
      const { reminderId, data } = props ?? {};

      return updateEntityReminderApiV1RemindersEntityReminderIdPatch(
        reminderId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateEntityReminderApiV1RemindersEntityReminderIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateEntityReminderApiV1RemindersEntityReminderIdPatch>
    >
  >;
export type UpdateEntityReminderApiV1RemindersEntityReminderIdPatchMutationBody =
  UpdateEntityReminderRequest;
export type UpdateEntityReminderApiV1RemindersEntityReminderIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Entity Reminder
 */
export const useUpdateEntityReminderApiV1RemindersEntityReminderIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateEntityReminderApiV1RemindersEntityReminderIdPatch
        >
      >,
      TError,
      { reminderId: string; data: UpdateEntityReminderRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateEntityReminderApiV1RemindersEntityReminderIdPatch>
  >,
  TError,
  { reminderId: string; data: UpdateEntityReminderRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateEntityReminderApiV1RemindersEntityReminderIdPatchMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cancel a pending reminder. Creator only.

A status change rather than a delete, so the row stays as history and the
sweep's `pending` claim can never pick it up again.
 * @summary Cancel Entity Reminder
 */
export const cancelEntityReminderApiV1RemindersEntityReminderIdDelete = (
  reminderId: string
) => {
  return customInstance<EntityReminder>({
    url: `/api/v1/reminders/entity/${reminderId}`,
    method: 'DELETE'
  });
};

export const getCancelEntityReminderApiV1RemindersEntityReminderIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelEntityReminderApiV1RemindersEntityReminderIdDelete
        >
      >,
      TError,
      { reminderId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelEntityReminderApiV1RemindersEntityReminderIdDelete
      >
    >,
    TError,
    { reminderId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelEntityReminderApiV1RemindersEntityReminderIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelEntityReminderApiV1RemindersEntityReminderIdDelete
        >
      >,
      { reminderId: string }
    > = (props) => {
      const { reminderId } = props ?? {};

      return cancelEntityReminderApiV1RemindersEntityReminderIdDelete(
        reminderId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelEntityReminderApiV1RemindersEntityReminderIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelEntityReminderApiV1RemindersEntityReminderIdDelete
      >
    >
  >;

export type CancelEntityReminderApiV1RemindersEntityReminderIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Entity Reminder
 */
export const useCancelEntityReminderApiV1RemindersEntityReminderIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelEntityReminderApiV1RemindersEntityReminderIdDelete
        >
      >,
      TError,
      { reminderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof cancelEntityReminderApiV1RemindersEntityReminderIdDelete>
  >,
  TError,
  { reminderId: string },
  TContext
> => {
  const mutationOptions =
    getCancelEntityReminderApiV1RemindersEntityReminderIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
